import React, { useState, useEffect, forwardRef, ReactElement } from 'react';
import api from "../components/api";
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import moment from'moment'
import LoaderIcon from'react-loading-icons'


interface iClienteUsuarios {

    cliente_id: number,
    nomeFantasia: string,
    cnpj: string,
    totalUsuarios: number,
    perfilDescricao: string,


}




const ClienteUsuarios = (props: any) => {


    const [resultado, setResultado] = useState<iClienteUsuarios[]>([])
    const [carregando, setCarregando] = useState<string>('none')

    const columns: MRT_ColumnDef<iClienteUsuarios>[] = [

        {
            accessorKey: 'nome',
            header: 'Nome',
            

        },


        {
            accessorKey: 'cpf',
            header: 'CPF',
            

        },


        {
            accessorKey: 'totalAcessos',
            header: 'Acessos',
            

        },


        {
            accessorKey: 'ultimoAcesso',
            header: 'Último acesso',
            

        },





        {
            accessorKey: 'perfilDescricao',
            header: 'perfil',
            Cell: ({ renderedCellValue, row }) => (
            
                renderedCellValue
           
            ),

        },
    ]

    useEffect(() => {

        if (props.cliente_id) {

            carregaUsuarios()
        }
        
    }, [props.cliente_id])


    const carregaUsuarios = () => {
    
        var dataPost = {
            cliente_id: props.cliente_id,
        }
        
        setCarregando('block')

        api.post('usuarioListaTodos', dataPost).then((result) => {

            props.setTotalUsuarios(result.data.length)

            setCarregando('none')
            setResultado(result.data)

        }).catch((err) => {

            setCarregando('none')
            console.log(err.response)

        })
    }

    

    return (
        <div>
            
            <div className="col-12 col-xl-12">
                            


                <center>
                <LoaderIcon.Puff stroke="#000" style={{ display: carregando }} />
                </center>


                <div className="col-lg-12" style={{ display: resultado.length == 0 ? 'none' : 'block'}}>


                    <MaterialReactTable

                        columns={columns}
                        data={resultado}
                        localization={MRT_Localization_PT_BR}
                        //rowsPerPage={20}
                        //options={options}
                        initialState={{ density: 'compact' }}
                        muiTableHeadCellProps={{
                            //easier way to create media queries, no useMediaQuery hook needed.
                            sx: {
                                fontSize: {
                                    xs: '8px',
                                    sm: '9px',
                                    md: '10px',
                                    lg: '11px',
                                    xl: '12px',
                                },
                            },
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                fontSize: {
                                    xs: '8px',
                                    sm: '9px',
                                    md: '10px',
                                    lg: '11px',
                                    xl: '12px',
                                },
                            },
                        }}
                        muiTableBodyRowProps={({ row }) => ({
                            onClick: () => {
                                //setShow(true);
                                //setCliente_id(row.original.cliente_id); 
                                //setNow(moment().format('YYYYMMDDHHmmss'))
                            },
                            sx: {
                                cursor: 'pointer', 
                            },
                        })}
                    />

                </div>


        </div>
        


        </div>
    )
}

export default ClienteUsuarios;
